import { Router } from "@angular/router";

export abstract class RouteHelper {

    public static reloadCurrentRoute(router: Router) {
        const url = router.url;
        console.log('RouteHelper: Reloading current route...', url);
        router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            console.log('RouteHelper: Navigating back to original URL...', url);
            router.navigateByUrl(url);
        });
    }
}